'use client';
import { anatomy } from '@zag-js/color-picker';

const colorPickerAnatomy = anatomy.extendWith("view");

export { colorPickerAnatomy };
